import Vue from 'vue'
import Vuex from 'vuex'
// Modules
import localForage from 'localforage'
import VuexPersistence from 'vuex-persist'
import app from './app'
// eslint-disable-next-line import/no-cycle
import { auth } from './auth'
// eslint-disable-next-line import/no-cycle
import { userAccounts } from './account/user-accounts'
import { dashboard } from './dashboard/dashboard'
import { notifications } from './notifications'
import { susuSavings } from './susu-savings/susu-savings'
import { loans } from './susu-savings/loans'
import { hirePurchase } from './hire-purchase/index'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

const vuexLocal = new VuexPersistence({
  key: 'sikanii',
  storage: localForage.createInstance({
    storeName: 'sikanii',
    version: 1,
  }),
  asyncStorage: true,
  modules: [
    'auth',
    'userAccounts',
    'dashboard',
    'notifications',
    'susuSavings',
    'loans',
    'hirePurchase',
  ],
})

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    auth,
    userAccounts,
    performance,
    dashboard,
    notifications,
    susuSavings,
    hirePurchase,
    loans,
  },
  strict: process.env.DEV,
  plugins: [vuexLocal.plugin],
})
export default store

const initialStateCopy = JSON.parse(JSON.stringify(store.state))

export function resetState() {
  store.replaceState(JSON.parse(JSON.stringify(initialStateCopy)))
}
